import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  HrLabel,
  HrRed,
  HrGrey,
  HrGray,
  HrlighterGrey,
  HrlightestGrey,
  HrFlexContainer,
  HrBorderRadiusInputs,
  HrFontRegular,
  HrParagraph,
  HrFont
} from '@components/styles/hr-styles';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ErrorMessage } from '@hookform/error-message';
import { get } from 'lodash';
import { Controller } from 'react-hook-form';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

const HtmlTextarea = styled.textarea`
  background-color: ${(props) => props.background || ''};
  font-family: ${HrFont};
  padding: 8px 16px;
  font-size: 14px;
  color: ${(props) => props.color || HrGray};
  font-weight: ${(props) => props.fontWeight || HrFontRegular};
  min-height: ${(props) => props.minHeight || ' 170px'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  resize: none;
  border-radius: ${HrBorderRadiusInputs};
  border: 1px solid ${HrlighterGrey};
  &::placeholder {
    color: ${HrGrey};
    font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
  }

  &:focus {
    color: ${(props) => props.color || HrGray};
    border: 1px solid ${HrGray};
    outline: none;
  }

  &:focus::placeholder {
    color: ${HrGray};
  }

  &:disabled {
    background: ${HrlightestGrey};
    border: 1px solid ${HrlighterGrey};
    color: ${HrGrey};
    cursor: not-allowed;
  }

  &.error {
    color: ${HrRed};
    border: 1px solid ${HrRed};
  }
  &.error::placeholder {
    color: ${HrRed};
  }
`;
const CharacterCounter = styled.span`
  font-family: ${HrFont};
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  position: absolute;
  right: 16px;
  bottom: 8px;
  color: ${HrGrey};
`;

// const HelperLine = styled.span`
//   position: relative;
//   width: 100%;
// `;
export const Textarea = ({
  errorPosition,
  formState,
  handlerOnBlur,
  id,
  max,
  minHeight,
  placeholder,
  showCount,
  title,
  validate,
  value,
  control,
  handleKeyDown,
  disabled
}) => {
  const [numCharacters, setNumCharacters] = useState(value ? value.toString().length : 0);
  const { errors } = formState;
  const refCurrent = useRef(null);
  const _validate = {};
  const handleOnChange = (event) => {
    const { value: _v } = event.target;

    setNumCharacters(_v.length);
  };
  if (validate.required) {
    _validate.required = 'Campo obligatorio';
  }
  const err = get(errors, id);

  useEffect(() => {
    if (err) {
      refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      refCurrent.current?.focus();
    }
  }, [err]);

  useEffect(() => {
    setNumCharacters(value ? value.toString().length : 0);
  }, [value]);

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer width='100%' gap='8px' style={{ position: 'relative' }} ref={refCurrent}>
      {title && (
        <HrFlexContainer justifyContent='space-between'>
          <HrLabel
            cursor='auto'
            fontSizeSetting={fontSizeSetting}
            htmlFor={id}
            color={darkMode ? 'white' : ''}
            isRequired={validate.required}
            userSelect='none'
          >
            {title}
          </HrLabel>
          {errorPosition === 'top' && (
            <ErrorMessage
              errors={errors}
              name={id}
              render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
            />
          )}
        </HrFlexContainer>
      )}

      <HrFlexContainer width='100%'>
        <Controller
          control={control}
          name={id}
          rules={_validate}
          render={({ field }) => (
            <HtmlTextarea
              color={darkMode ? 'white' : ''}
              background={darkMode ? 'transparent' : ''}
              value={field.value}
              placeholder={placeholder}
              fontSizeSetting={fontSizeSetting}
              onChange={(e) => {
                field.onChange(e.target.value);
                handleOnChange(e);
              }}
              maxLength={max}
              minHeight={minHeight}
              disabled={disabled}
              className={get(errors, id) ? 'error' : ''}
              onBlur={(e) => {
                handlerOnBlur(e);
              }}
              onKeyDown={(e) => {
                handleKeyDown(e);
              }}
            />
          )}
        />

        {showCount && <CharacterCounter>{`${numCharacters}/${max}`}</CharacterCounter>}
      </HrFlexContainer>
    </HrFlexContainer>
  );
};
Textarea.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  validate: PropTypes.object,
  placeholder: PropTypes.string,
  max: PropTypes.number,
  showCount: PropTypes.bool,
  minHeight: PropTypes.string,
  errorPosition: PropTypes.string,
  formState: PropTypes.object,
  handlerOnBlur: PropTypes.func,
  handleKeyDown: PropTypes.func,
  disabled: PropTypes.bool
};

Textarea.defaultProps = {
  name: '',
  value: '',
  validate: {},
  max: 1000,
  showCount: true,
  placeholder: '',
  minHeight: '170px',
  errorPosition: 'top',
  formState: { errors: {} },
  handlerOnBlur: () => {},
  handleKeyDown: () => {},
  disabled: false
};
